export default __webpack_public_path__ + "static/media/icons8-retro-alarm-clock-96.7b97273c.svg";